import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e413876"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "キャンペーンコード・代理店コード", -1))
const _hoisted_2 = { class: "block coupon-codes" }
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "campaign-code-input" }, "キャンペーンコード", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "agency-code-input" }, "代理店コード", -1))
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_input = _resolveComponent("common-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.defaultCampaignCode)
          ? (_openBlock(), _createBlock(_component_common_input, {
              key: 0,
              "model-value": _ctx.campaignCode,
              name: "campaign-code-input",
              onInput: _ctx.onInputCampaignCode,
              disabled: _ctx.isSetCode
            }, null, 8, ["model-value", "onInput", "disabled"]))
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "common-input",
              value: _ctx.defaultCampaignCode,
              disabled: ""
            }, null, 8, _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (!_ctx.defaultAgencyCode)
          ? (_openBlock(), _createBlock(_component_common_input, {
              key: 0,
              "model-value": _ctx.agencyCode,
              name: "agency-code-input",
              onInput: _ctx.onInputAgencyCode,
              disabled: _ctx.isSetCode
            }, null, 8, ["model-value", "onInput", "disabled"]))
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "common-input",
              value: _ctx.defaultAgencyCode,
              disabled: ""
            }, null, 8, _hoisted_8))
      ])
    ])
  ], 64))
}